import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/img/cog.svg'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "boxTitle" }, null, -1)
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "boxTitle" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "me-1" }
const _hoisted_10 = { class: "ms-1" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_12 = { class: "obiettivoLineContainer" }
const _hoisted_13 = { class: "obiettivoLine target" }
const _hoisted_14 = { class: "left" }
const _hoisted_15 = { class: "left" }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_month_navigator = _resolveComponent("month-navigator")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_month_navigator, {
          modelValue: _ctx.periodo,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.periodo) = $event)),
            _ctx.init
          ]
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_localized_text, {
            localizedKey: "Obiettivo mensile",
            text: "Obiettivo mensile"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-link",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModalObiettivo && _ctx.openModalObiettivo(...args)))
          }, [
            _hoisted_7,
            _createVNode(_component_localized_text, {
              localizedKey: "Imposta obiettivo",
              text: "Imposta obiettivo"
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link d-flex align-items-center",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.useNegatives = !_ctx.useNegatives))
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-control pointer",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.useNegatives) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.useNegatives]
                ]),
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Includi manuali",
                    text: "Includi manuali"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_localized_text, {
              localizedKey: "Target",
              text: "Target"
            })
          ]),
          _createElementVNode("div", {
            class: "right",
            style: _normalizeStyle(_ctx.targetWidth)
          }, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.vm.obiettivoMensile)), 5)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["obiettivoLine result", { red: !_ctx.isOver, green: _ctx.isOver }])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_localized_text, {
              localizedKey: "Io",
              text: "Io"
            })
          ]),
          _createElementVNode("div", {
            class: "right",
            style: _normalizeStyle(_ctx.resultWidth)
          }, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.vm.risultato)), 5)
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["obiettivoLineResume", { 'text-green': _ctx.isOver }])
      }, [
        (_ctx.isOver)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "+"))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(_ctx.risultatoPerc, 0)) + "% ", 1)
      ], 2)
    ])
  ]))
}